<script setup>
    import { reactive } from 'vue';
    import AnimatedNumber from './AnimatedNumber.vue'

    const props = defineProps({
        stats: {
            type: Array,
            default: () => [],
        },

        columns: {
            type: Number,
            default: 2,
            max: 4,
        },
    });

    const GridStyledClass = reactive({
        'columns-2': props.columns === 2,
        'columns-3': props.columns === 3,
        'columns-4': props.columns === 4,
    });
</script>

<template>
    <div class="statsTextGrid" :class="GridStyledClass">
        <div class="statsTextGrid__row" v-for="(stat) in stats">
            <div class="statsTextGrid__label">{{ stat.label }}</div>
            <div class="statsTextGrid__value">
                <AnimatedNumber v-if="stat.animated" :value="stat.value" :decimals="stat?.decimals || 0" :suffix="stat?.suffix" />
                <template v-else>
                    {{ stat.value }}
                </template>
            </div>
        </div>
    </div>    
</template>

<style lang="scss">
    .statsTextGrid {
        display: grid;
        flex-direction: column;
        gap: 1rem 2rem;
        margin-bottom: 3rem;

        @media (min-width: 768px) {
            &.columns-2 {
                grid-template-columns: 1fr 1fr
            }

            &.columns-3 {
                grid-template-columns: 1fr 1fr 1fr;
            }

            &.columns-4 {
                grid-template-columns: 1fr 1fr 1fr 1fr;
            }
        }

        &__row {
            display: flex;
            justify-content: space-between;
        }
    
        &__label {
            font-weight: 600;
        }

        &__value {
            font-weight: 100;
        }
    }
</style>